<template>
  <div class="trade-success-com">
    <div class="module h-100">
      <div class="module-head">
        <span class="last-price">{{ $t('labels.trade.tradeHistory') }}</span>
        <!--<span class="last-price">最新价 0.69845 USDT</span>
        <span class="legal-tender">≈ 142.54 CNY</span>-->
      </div>
      <div v-if="loading" class="module-body d-flex justify-center align-center">
        <div class="exchange-loading">
          <div class="loading-inner d-flex justify-center align-center">
            <v-progress-circular class="mr-1" color="#ffffff" indeterminate size="25" width="3"></v-progress-circular>
            <span class="loading-text color-fff">{{ $t('labels.loading') }}...</span>
          </div>
        </div>
      </div>
      <div v-else class="module-body">
        <ul class="trade-success-list-caption">
          <li>{{ $t('labels.trade.time') }}</li>
          <li>{{ $t('labels.trade.price') }}</li>
          <li>{{ $t('labels.trade.history.vol') }}</li>
        </ul>
        <div class="relative-position" :class="{ 'd-flex justify-center align-center': model.length == 0 }">
          <ul class="trade-success-list">
            <v-tooltip v-for="(item, index) in model" :key="index" right>
              <template v-slot:activator="{ on }">
                <li
                  v-on="on"
                  v-bind:class="{ buy: item.type == 1, sell: item.type == 2 }"
                  @click="onClick(decimalRetain(item.price, getPrecision(1 /* priceDec */)))"
                >
                  <div>
                    <div>{{ showTime(item.timestamp) }}</div>
                  </div>
                  <div :class="{ 'color-buy': item.type == 1, 'color-sell': item.type == 2 }">
                    <div>{{ decimalRetain(item.price, getPrecision(1 /* priceDec */)) }}</div>
                  </div>
                  <div>
                    <div>{{ decimalRetain(item.volume, getPrecision(2 /* volDec */)) }}</div>
                  </div>
                </li>
              </template>
              <span>{{ showTime(item.timestamp, 'YYYY-MM-DD HH:mm:ss') }}</span>
            </v-tooltip>
          </ul>

          <div v-if="0 >= model.length" class="trade-success-no-data color-fff">{{ $t('common.noRecords') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { socketName } from '@/common/constants/globalConfig';
import { tradeApi } from '@/api/exchange.page';
import { mapGetters } from 'vuex';
import tool from '@/common/js/tool';
import { getterTypes } from '@/store/getter-types';
import moment from 'moment';

export default {
  name: 'TradeSuccess',
  props: {
    model: {
      type: Array,
      default: []
    }
  },
  watch: {
    model(value) {
      this.loading = false;
    }
  },
  methods: {
    // init(data) {
    //   if (null != data && undefined != data) {
    //     if (0 < data.length) {
    //       if (data.length > this.maxRow) {
    //         data = data.slice(0, this.maxRow);
    //       }

    //       this.data = data;
    //     }
    //   }

    //   this.mergeQueue();

    //   return;
    // },
    // onMessage(timestamp, price, volume, type) {
    //   if (this.autoMerge) {
    //     return this.createQueue(timestamp, price, volume, type);
    //   } else {
    //     return;
    //   }
    // },
    // debug(value) {
    //   console.log('TH', value);
    // },
    // createQueue(timestamp, price, volume, type) {
    //   if (null == this.queue) {
    //     this.queue = [];
    //   }

    //   this.queue.push({
    //     timestamp,
    //     price,
    //     volume,
    //     type
    //   });
    //   return;
    // },
    // clearQueue() {
    //   this.queue = null;
    // },
    // mergeQueue() {
    //   if (null != this.queue) {
    //     this.insert();
    //     this.clearQueue();
    //   }

    //   this.hideLoading();
    //   this.startAutoMerge();
    //   return;
    // },
    // startAutoMerge() {
    //   if (!this.autoMerge) {
    //     this.autoMerge = true;
    //     this.interval = setInterval(() => {
    //       this.mergeQueue();
    //     }, this.autoMergeDelay);
    //   }
    // },
    // hideLoading() {
    //   this.loading = false;
    // },
    // showLoading() {
    //   this.loading = true;
    // },
    // insert() {
    //   let queue = this.queue;

    //   if (null == this.data || undefined == this.data) {
    //     this.data = [];
    //   }

    //   if (queue.length > this.maxRow) {
    //     this.data = queue.slice(0, this.maxRow);
    //   } else {
    //     let data = this.data;

    //     if (this.data.length + queue.length > this.maxRow) {
    //       data = data.slice(0, data.length - queue.length);
    //     }

    //     for (let i = 0; i < queue.length; i++) {
    //       let tmp = [queue[i]];
    //       data = tmp.concat(data);
    //     }

    //     this.data = data;
    //   }

    //   return;
    // },
    // getQueue() {
    //   return this.queue;
    // },
    // reset() {
    //   clearInterval(this.interval);
    //   this.showLoading();
    //   this.data = null;
    //   this.queue = null;
    //   this.interval = null;
    //   this.autoMerge = false;
    // },
    showTime(timestamp, format = null) {
      if (!format) {
        format = 'HH:mm:ss';
      }
      // return moment(timestamp).format('DD-MM HH:mm:ss');
      return moment(timestamp).format(format);
    },
    getPrecision(flag /* 1 = priceDec, 2 = volDec */) {
      if (this.Getter_Current_Market) {
        if (flag === 1) {
          return this.Getter_Current_Market.priceDec;
        } else if (flag === 2) {
          return this.Getter_Current_Market.volDec;
        } else if (flag === 3) {
          /* return this.Getter_Current_Market.priceDec > this.Getter_Current_Market.volDec ?
            this.Getter_Current_Market.priceDec : this.Getter_Current_Market.volDec; */
          return this.Getter_Current_Market.priceDec + this.Getter_Current_Market.volDec;
        }
      }
      return '';
    },
    // 将数字格式化到指定位数的小数
    decimalRetain: tool.decimalRetain,
    onClick(price) {
      this.$emit('rowClick', price);
      // this.$parent.$refs.exchangeForm.$refs.priceBuy[0].model = price;
      // this.$parent.$refs.exchangeForm.$refs.priceSell[0].model = price;
      // this.$parent.$refs.exchangeForm.$refs.volumeBuy[0].clear();
      // this.$parent.$refs.exchangeForm.$refs.volumeSell[0].clear();
    }
  },
  computed: {
    ...mapGetters([getterTypes.Getter_Current_Market])
  },
  data() {
    return {
      // 交易类型
      // transTypeMap: {
      //   '1': '买入',
      //   '2': '卖出'
      // },
      // lastSubscribeChannel: '',
      data: null,
      loading: true
      // queue: null,
      // interval: null,
      // autoMerge: false,
      // autoMergeDelay: 500,
      // maxRow: !window.env.maxTradeHistoryRow ? 20 : window.env.maxTradeHistoryRow
    };
  }
};
</script>

<style lang="stylus" scoped>
@import 'trade-history.styl';

.trade-success-com {
 // height: calc(100vh - 440px);
  height: calc(45% - 10px);
  background-color: #17232c;
}

.h-100 {
  height: 100%;
}

.module-head {
  height: 38px;
}

.module-body {
  height: calc(100% - 38px);
  overflow: auto;
}

.relative-position {
  min-height: 100%;
}

.trade-success-list > li:hover {
  cursor: pointer;
}

.trade-success-list > li > div > div {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
